<template>
    <div :style="{'max-width': '99%', 'margin-top': '10px'}" class="mx-2 mx-md-auto glass-theme fade-in-page">
        <!-- API Loading Overlay with Animation -->
        <transition name="loading-overlay">
            <div v-if="apiLoading" class="loading-overlay">
                <div class="loading-card">
                    <div class="loading-animation">
                        <div class="loading-ring">
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="loading-logo">
                                <i class="fas fa-boxes"></i>
                            </div>
                        </div>
                    </div>
                    <div class="loading-text">
                        <h3>{{ loadingMessage }}</h3>
                        <div class="loading-dots">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                    </div>
                    <div class="loading-progress">
                        <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                    </div>
                    <div class="loading-tips">
                        <p class="tip-text">{{ currentTip }}</p>
                    </div>
                </div>
            </div>
        </transition>

        <b-card-text><h3>ALL ORDERS</h3></b-card-text>

        <b-modal id="modal-vendor-order-all-orders" scrollable title="Vendor Order" size="md" hide-footer @hide="refresh_vendor_order" ref="vendor_order_modal">
            <VendorOrder :viewdata="{vendor_order: {vendor_order_id: vendor_order_obj.vendor_order_id}, packet: packet}"  />
        </b-modal>

        <b-modal id="modal-comments-all-orders" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>

        <div
          v-if="isMobile"
          class="d-flex justify-content-between align-items-center mb-2 py-2"
        >
          <b-button
            size="sm"
            variant="outline-primary"
            @click="filtersVisible = !filtersVisible"
          >
            <b-icon-funnel-fill class="mr-1" />
            {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
          </b-button>
        </div>

        <b-collapse :visible="!isMobile || filtersVisible" style="width: 100%;">
            <b-card class="glass-card">
                <b-alert show style="display: inline-block; vertical-align: top;" class="glass-alert">
                    <div style="display: inline-block;">
                        <div>ORDER DATE RANGE</div>
                        <date-picker
                            v-model="order_date_range"
                            range
                            format="MM-DD-YYYY"
                            value-type="format"
                            style="font-size: 14px; text-align: center; border: 1px solid gray; width: 210px;"
                            placeholder="Select date range"
                        ></date-picker>
                    </div>
                    <div style="display: inline-block;">
                        <div>INVOICE STATUS</div>
                        <b-form-select size="sm" style="width: 150px;" :options="statuses" v-model="status"></b-form-select>
                    </div>
                    <div style="display: inline-block;">
                        <div>LOCATION</div>
                        <b-form-select
                            size="sm"
                            style="width: 150px;"
                            :options="location_options"
                            v-model="location_id"
                        ></b-form-select>
                    </div>

                    <div style="display: inline-block;">
                        <div>MERCH STATUS</div>
                        <b-form-select size="sm" style="width: 120px;" :options="merchandise_statuses" v-model="merchandise_status"></b-form-select>
                    </div>

                    <div style="display: inline-block;">
                        <div>PYMT METHODS</div>
                        <b-form-select size="sm" style="width: 120px;" :options="payment_methods" v-model="payment_method"></b-form-select>
                    </div>

                    <!-- Order Type Filter -->
                    <div style="display: inline-block;">
                        <div>ORDER TYPE</div>
                        <b-form-select 
                            size="sm" 
                            style="width: 140px;" 
                            :options="order_type_options" 
                            v-model="order_type"
                        ></b-form-select>
                    </div>

                    <div style="display: inline-block;">
                        <div>INVOICE #</div>
                        <b-form @submit="fetch_data" autocomplete="off">
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="invoice_id-label"
                                        label-for="invoice_id"
                                        description=""
                                        align="left"
                                    >
                                        <b-form-input
                                            id="invoice_id"
                                            v-model="invoice_id"
                                            type="text"
                                            style="margin: 0px;"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-form>
                    </div>

                    <div style="display: inline-block;">
                        <b-button size="sm" @click="fetch_data" class="glass-btn">FETCH</b-button>
                    </div>
                </b-alert>

                <b-alert show variant="secondary" style="display: inline-block; vertical-align: top;" class="glass-alert">
                    <div>No# OF RESULTS</div>
                    <b-form-select size="md" style="width: 150px;" :options="pagination_options" v-model="nresults"></b-form-select>
                </b-alert>

                <b-alert show style="display: inline-block; vertical-align: top;" class="py-4 glass-alert">
                    <b-button size="md" variant="primary" @click="fetch_data_pending" class="glass-btn">FETCH PENDING</b-button>
                </b-alert>
            </b-card>
        </b-collapse>

        <div style="margin-top: 10px;" class="text-monospace">
            <!-- Fixed: Removed table, using div container instead -->
            <div v-if="items.length > 0" class="text-monospace glass-table-container" style="height: 1024px; width: 100%; overflow: auto;">
                <div style="width: 100%; min-width: 1420px;">
                    <!-- HEADER ROW - Added all column headers -->
                    <div style="padding: 0px; background: rgba(54, 64, 80, 0.95); backdrop-filter: blur(5px); margin-bottom: 10px; border: 1px solid rgba(0,0,0,0.3); border-radius: 8px; color: white; font-weight: bold; font-size: 11px;">
                        <b-container fluid style="margin: 0px; padding: 0px; padding-left: 3px; max-width: 100%;">
                            <b-row no-gutters>
                                <b-col cols="2" class="header-col" style="min-width: 10%; max-width: 10%; padding: 8px 2px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">
                                    DATE
                                </b-col>
                                <b-col cols="1" class="header-col" style="min-width: 10%; max-width: 10%; padding: 8px 2px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">
                                    INVOICE #
                                </b-col>
                                <b-col cols="1.8" class="header-col" style="min-width: 10%; max-width: 10%; padding: 8px 2px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">
                                    CUSTOMER INFO
                                </b-col>
                                <b-col cols="0.8" class="header-col" style="min-width: 10%; max-width: 10%; padding: 8px 2px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">
                                    STORE LOCATION
                                </b-col>
                                <b-col cols="0.8" class="header-col" style="min-width: 10%; max-width: 10%; padding: 8px 2px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">
                                    CREATED BY
                                </b-col>
                                <b-col cols="1" class="header-col" style="min-width: 10%; max-width: 10%; padding: 8px 2px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">
                                    NO# ITEMS
                                </b-col>
                                <b-col cols="1" class="header-col" style="min-width: 8%; max-width: 8%; padding: 8px 2px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">
                                    MERCHANDISE STATUS
                                </b-col>
                                <b-col cols="1" class="header-col" style="min-width: 7%; max-width: 7%; padding: 8px 2px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">
                                    DELIVERY TYPE
                                </b-col>
                                <b-col cols="1" class="header-col" style="min-width: 5%; max-width: 5%; padding: 8px 2px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">
                                    ITEM STATUS
                                </b-col>
                                <b-col cols="0.7" class="header-col" style="min-width: 5%; max-width: 5%; padding: 8px 2px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">
                                    DELIVERY DATE
                                </b-col>
                                <b-col cols="1.8" class="header-col" style="min-width: 15%; max-width: 15%; padding: 8px 2px; text-align: center;">
                                    ACTION
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>

                    <!-- DATA ROWS -->
                    <div 
                        v-for="(item, idx) in displayedItems"
                        :key="item.invoice_id"
                        style="padding: 0px; background: rgba(239, 239, 239, 0.85); backdrop-filter: blur(5px); margin-bottom: 10px; border: 1px solid rgba(0,0,0,0.2); border-radius: 8px;"
                        :class="{ 'invoice-with-vendor-orders': invoiceHasVendorOrderItems(item), 'fade-in-row': true }"
                        :style="{ animationDelay: `${idx * 0.02}s` }"
                    >
                        <b-container fluid style="margin: 0px; padding:0px; padding-left: 3px; font-size: 12px; max-width: 100%;">
                            <b-row no-gutters>
                                <b-col cols="2" class="b-col1" style="min-width: 10%; max-width: 10%" @click="sortby('order_date')">{{ item.order_date }}</b-col>
                                <b-col cols="1" class="b-col1" style="min-width: 10%; max-width: 10%">{{ (item.invoice_id) }}</b-col>
                                <b-col cols="1.8" class="b-col1" style="min-width: 10%; max-width: 10%">
                                    <div>{{ item.fullname }}</div>
                                    <div># {{ item.phone }}</div>
                                    <div>@ {{ item.email }}</div>
                                </b-col>
                                <b-col cols="0.8" style="min-width: 10%; max-width: 10%" class="b-col1" @click="sortby('location_id')"> {{(packet.locationsdict[item.location_id] || "").toUpperCase()}}</b-col>
                                <b-col cols="0.8" style="min-width: 10%; max-width: 10%" class="b-col1" @click="sortby('username')">{{( item.username || "").toUpperCase()}}</b-col>

                                <b-col class="b-col1" cols="1" style="min-width: 10%; max-width: 10%" :style="{'background-color': ((item.has_discount ? 'rgba(255, 225, 7, 0.45)': 'none')) }">
                                    <div style="margin: 5px;">{{item.n_items}} ITEMS</div>
                                    <div style="margin: 5px;">${{(item.total || 0.0).toFixed(2)}}</div>
                                    <div style="margin: 5px;">
                                        <b-badge v-for="pm,pmidx in item.payment_methods" :key="pmidx" style="margin: 3px;">
                                            {{ (pm || '').toUpperCase() }}
                                        </b-badge>
                                    </div>
                                </b-col>

                                <b-col class="b-col1" cols="1" style="min-width: 8%; max-width: 8%; text-align: center;">
                                    <div>
                                        <div v-if="item.has_in_stocks > 0" style="background: lightgreen; color: black; display: block; margin: auto;" @click="sortby('has_in_stocks')">
                                            {{ item.has_in_stocks }} IN-STOCKS
                                        </div>
                                        <div v-if="item.has_backorders > 0" style="background: yellow; color: black; display: block; margin: auto;" @click="sortby('has_backorders')">
                                            {{ item.has_backorders }} BACKORDERS
                                        </div>
                                        <div v-if="item.has_specials > 0" style="background: pink; color: black; display: block; margin: auto;" @click="sortby('has_specials')">
                                            {{ item.has_specials }} SPECIALS
                                        </div>
                                    </div>
                                </b-col>

                                <!-- ORDER TYPE COLUMN (Delivery Type) -->
                                <b-col class="b-col1" cols="1" style="min-width: 7%; max-width: 7%; text-align: center; font-size: 11px; padding: 2px;">
                                    <div v-if="getOrderTypeSummary(item)">
                                        <div v-if="item.home_delivery_count > 0" 
                                             style="background: #e3f2fd; color: black; margin: 1px; padding: 1px 3px; border-radius: 3px; display: inline-block;">
                                            {{ item.home_delivery_count }} HOME DELIVERY
                                        </div>
                                        <div v-if="item.store_pickup_count > 0" 
                                             style="background: #f3e5f5; color: black; margin: 1px; padding: 1px 3px; border-radius: 3px; display: inline-block;">
                                            {{ item.store_pickup_count }} STORE PICKUP
                                        </div>
                                        <div v-if="item.customer_takes_count > 0" 
                                             style="background: #e8f5e9; color: black; margin: 1px; padding: 1px 3px; border-radius: 3px; display: inline-block;">
                                            {{ item.customer_takes_count }} CUSTOMER TAKES
                                        </div>
                                    </div>
                                    <div v-else style="color: #666; padding: 5px;">
                                        No Type
                                    </div>
                                </b-col>

                                <!-- DELIVERY STATUS COLUMN (Item Status) -->
                                <b-col class="b-col1" cols="1" style="min-width: 5%; max-width: 5%; text-align: center; font-size: 11px; padding: 2px;" @click="sortby('delivered_count')">
                                    <div v-if="item.delivered_count > 0 || item.not_delivered_count > 0">
                                        <div v-if="item.delivered_count > 0" 
                                             style="background: #4caf50; color: white; margin: 1px; padding: 2px 4px; border-radius: 3px; display: inline-block; font-weight: bold;">
                                            {{ item.delivered_count }} DLVRD
                                        </div>
                                        <div v-if="item.not_delivered_count > 0" 
                                             style="background: #ff9800; color: black; margin: 1px; padding: 2px 4px; border-radius: 3px; display: inline-block; font-weight: bold;">
                                            {{ item.not_delivered_count }} NOT DLVRD
                                        </div>
                                    </div>
                                    <div v-else style="color: #666; padding: 5px;">
                                        No Data
                                    </div>
                                </b-col>

                                <!-- Delivery dates column -->
                                <b-col class="b-col1" cols="0.7" style="min-width: 5%; max-width: 5%; text-align: center;" @click="sortby('delivery_dates')">
                                    <div v-for="ddate, ddidx in item.delivery_dates" :key="ddidx" style="padding: 3px; text-align: center; background: lightyellow; color: black;">
                                        {{ ddate }}
                                    </div>
                                </b-col>

                                <!-- Action column -->
                                <b-col cols="1.8" class="b-col1" style="min-width: 15%; max-width: 15%; text-align: center;">
                                    <div style="display: block; margin: 5px;">
                                        <div style="display: inline-block; vertical-align: top;">
                                            <span v-if="item.status == 1">
                                                <div style="padding: 1px; background: lightgreen; width: 70px;">PROCESSED</div>
                                            </span>
                                            <span v-else>
                                                <button @click="mark_processed(item)" class="glass-btn-small"> PROCESS </button>
                                            </span>
                                        </div>

                                        <div style="display: inline-block; vertical-align: top;">
                                            <button
                                                size="sm"
                                                @click="show_details(item)"
                                                v-b-tooltip.hover="!isMobile ? 'Show/Hide Items' : null"
                                                class="glass-btn-small"
                                            >
                                                {{ item.show_details ? 'HIDE' : 'SHOW' }}
                                            </button>
                                        </div>
                                    </div>

                                    <div style="display: block; margin: 5px;">
                                        <b-dropdown size="sm" variant="primary" id="dropdown-1" text="ACTIONS" class="m-2" style="font-size: 12px;">
                                            <b-dropdown-item @click="navigateToInvoice(item.invoice_id)">VIEW INVOICE</b-dropdown-item>
                                            <b-dropdown-item @click="saveItem(item, item.products[0].items)">SAVE ALL</b-dropdown-item>
                                            <b-dropdown-item @click="assign_all(item)">ASSIGN INVENTORY</b-dropdown-item>
                                            <b-dropdown-item @click="void_invoice(item.invoice_id)">VOID INVOICE</b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-container>

                        <!-- Expanded details section -->
                        <div v-show="item.show_details" style="">
                            <div>
                                <b-alert show v-if="item.loading" variant="secondary" style="height: 70px; margin: 0px;">
                                    <loading
                                        :active="item.loading"
                                        :can-cancel="false"
                                        :is-full-page="false"
                                        :width="50"
                                        :height="50">
                                    </loading>
                                </b-alert>
                                <div style="width: 100%; max-height: 2000px;">
                                    <div v-if="item.products && item.products.length > 0 && item.products[0].items && item.products[0].items.length > 0" style="padding: 0px;">
                                        <table style="width: 100%; max-width: 100%;">
                                            <thead>
                                                <tr>
                                                    <th class="ipt_tdhr2">SKU</th>
                                                    <th class="ipt_tdhr2">DESCRIPTION</th>
                                                    <th class="ipt_tdhr2">VENDOR</th>
                                                    <th class="ipt_tdhr2" style="width: 30px;">QTY</th>
                                                    <th class="ipt_tdhr2">TYPE</th>
                                                    <th class="ipt_tdhr2">ORDER</th>
                                                    <th class="ipt_tdhr2">MERCHDS STATUS</th>
                                                    <th class="ipt_tdhr2">DROP LOCATION</th>
                                                    <th class="ipt_tdhr2">DELIVERY LOC</th>
                                                    <th class="ipt_tdhr2">ITEM PICK FROM</th>
                                                    <th class="ipt_tdhr2">DELIVERY DATE</th>
                                                    <th class="ipt_tdhr2">DEL STATUS</th>
                                                    <th class="ipt_tdhr2">RETURNS</th>
                                                    <th class="ipt_tdhr2">ACTION</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="product, pidx in item.products[0].items" :key="pidx">
                                                    <td class="ipt_tdr3">
                                                        <span v-if="product.item_type == 1">
                                                            {{ product.product_sku }}
                                                        </span>
                                                        <span v-else>
                                                            <b-input size="sm" v-model="product.product_sku" style="margin: 5px;"></b-input>
                                                            <button @click="update_special_sku(item, product)" class="glass-btn-small">UPDATE SKU</button>
                                                        </span>
                                                    </td>
                                                    <td class="ipt_tdr3">{{ product.product_name || product.product_sku }}</td>
                                                    <td class="ipt_tdr3">{{ product.vendor }}</td>
                                                    <td class="ipt_tdr3">{{ product.quantity }}</td>
                                                    <td class="ipt_tdr3">
                                                        <div v-if="product.item_type == 1" style="background: none; color: black; width: 100%; font-weight: bold;">R</div>
                                                        <div v-else style="background: crimson; color: white; width: 100%; font-weight: bold;">S</div>
                                                    </td>
                                                    <td class="ipt_tdr3">
                                                        <div v-if="product.order_type == 'home_delivery'">HDL</div>
                                                        <div v-else-if="product.order_type == 'store_pickup'">STP</div>
                                                        <div v-else-if="product.order_type == 'customer_takes'">TKN</div>
                                                    </td>
                                                    <td class="ipt_tdr3" style="text-align: center;">
                                                        <div v-if="product.state == 1" style="font-size: 11px; padding: 4px;">
                                                            {{ getMerchandiseStatusLabel(product.merchandise_status) }}
                                                        </div>
                                                        <b-form-select 
                                                            v-else
                                                            :options="merchandise_statuses" 
                                                            size="sm" 
                                                            readonly 
                                                            style="width: 100px; font-size: 11px;" 
                                                            v-model="product.merchandise_status"  
                                                            @change="saveItem(item, item.products[0].items)" 
                                                           >
                                                        </b-form-select>

                                                        <div v-if="product.vendor_order_id" style="width: 100%;">
                                                            <div style="font-size: 10px; padding: 1px; background-color: #fff59d; cursor: default; pointer-events: none;">
                                                                <div>VENDOR ORDER # {{product.vendor_order_id}}</div>
                                                                <div>VENDOR = {{product.vendor}}</div>
                                                                <div>STATUS = {{vendor_order_statuses_dict[product.vendor_order_status]}}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="ipt_tdr3 px-1" style="font-size: 10px;">{{ packet.locsubsdict[product.ship_locsub] || "" }}</td>
                                                    <td class="ipt_tdr3 px-1" style="font-size: 10px;">{{ packet.locsubsdict[product.drop_locsub] || "" }}</td>
                                                    <td class="ipt_tdr3">
                                                        <b-form-select
                                                            size="sm"
                                                            style="font-size: 10px; width: 200px;"
                                                            :value="getProductDisplayLocsub(product)"
                                                            @input="updateProductLocsub(item, product, $event)"
                                                            :disabled="product.order_type == 'customer_takes'"
                                                        >
                                                            <b-form-select-option
                                                                v-for="locsub in getAvailableLocsubs(product)"
                                                                :value="locsub.value"
                                                                :key="locsub.value"
                                                                :style="isOutOfStock(product, locsub) ? 'color: red; font-style: italic;' : ''"
                                                            >
                                                                {{ all_loc_inventory_dict[concater([product.product_sku, locsub.location_id, locsub.sublocation_id])] || 0 }}
                                                                -
                                                                {{ locsub.location }} | {{ locsub.sublocation }}
                                                                {{ isOutOfStock(product, locsub) ? '(Out of Stock)' : '' }}
                                                            </b-form-select-option>
                                                        </b-form-select>
                                                    </td>
                                                    <td class="ipt_tdr3">
                                                        <date-picker v-model="product.delivery_date" format="MM-DD-YYYY" valueType="format" style="font-size: 12px !important; width: 130px; text-align: center;"
                                                        :disabled="product.order_type == 'customer_takes'"
                                                        @change="saveItem(item, item.products[0].items)"
                                                        ></date-picker>
                                                    </td>
                                                    <td class="ipt_tdr3">{{ states_dict[product.state] }}</td>
                                                    <td class="ipt_tdr3">{{ product.return_quantity }}</td>
                                                    <td class="ipt_tdr3">
                                                        <b-dropdown size="sm" variant="secondary" id="dropdown-1" text="ACTIONS" class="m-2" style="font-size: 12px;">
                                                            <b-dropdown-item v-if="product.modifiable" @click="saveItem(item, item.products[0].items)">SAVE</b-dropdown-item>
                                                            <b-dropdown-item v-if="product.modifiable" @click="allow_modify_item(product, false)">DISALLOW MODIFY</b-dropdown-item>
                                                            <b-dropdown-item v-if="!product.modifiable" @click="allow_modify_item(product, true)">ALLOW MODIFY</b-dropdown-item>
                                                            <b-dropdown-item @click="show_comments(product)">COMMENTS ({{ product.n_comments }})</b-dropdown-item>
                                                            <b-dropdown-item @click="apply_delivery_date_to_all(item, product)">APPLY DELIVERY DATE TO ALL ITEMS</b-dropdown-item>
                                                            <b-dropdown-item v-if="product.merchandise_status == 2" @click="create_vendor_order(product)">CREATE BACKORDER</b-dropdown-item>
                                                            <b-dropdown-item v-if="product.merchandise_status == 3" @click="create_vendor_order(product)">CREATE SPECIAL ORDER</b-dropdown-item>
                                                        </b-dropdown>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <b-alert show variant="warning">No Data To Show</b-alert>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import global_vars from '@/utilities/global_vars'
    import mappings from '@/utilities/mappings'
    import Requestor from '@/utilities/Requestor'
    import VendorOrder from '@/components/importables/VendorOrder'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { BIconFunnelFill } from "bootstrap-vue";
    import ItemComments from '@/components/importables/ItemComments'

    export default {
        name: "AdminToolsAllOrders2",
        components: {'Loading': Loading,'VendorOrder': VendorOrder, 'ItemComments': ItemComments, 'DatePicker': DatePicker},
        data: function(){
            return {
                sort_asc: true,
                items: [],
                packet: {},
                items_being_loaded: false,
                date_counts: [],
                global_vars: global_vars,
                active_date: null,
                location_id: null,
                location_options: [],
                order_date_range: [],
                all_loc_inventory_dict: {},
                date_type_options: [
                    {value: "delivery_date", text: "Delivery Dates"},
                    {value: "order_date", text: "Order/Sale Dates"}
                ],
                date_type: "order_date",
                order_types_dict: {
                    "customer_takes": "TAKEN",
                    "store_pickup": "STORE PICKUP",
                    "home_delivery": "HOME DELIVERY"
                },
                update_disabled: false,
                order_date: null,
                delivery_date: null,
                statuses: [
                    {"value": 0, "text": "NEW"},
                    {"value": 1, "text": "OPEN"},
                    {"value": 2, "text": "PROCESSED ONLY"},
                    {"value": 3, "text": "BACKORDER"},
                    {"value": 4, "text": "PARTIAL"},
                    {"value": 5, "text": "DELIVERED"},
                ],
                statuses_dict: {
                    0: {name: "NEW", bg: "#dcedc8", color: "black"},
                    1: {name: "PROCESSED ONLY", bg: "#fff59d", color: "black"},
                    2: {name: "DELIVERED", bg: "violet", color: "black"},
                },
                status: 0,
                merchandise_status: null,
                payment_method: null,
                invoice_id: null,
                allowed_locsubs: [],
                item_types: {1: "REGULAR", 2: "SPECIAL"},
                order_types: {
                    "home_delivery": "HOME DLVRY",
                    "store_pickup": "STORE PICKUP",
                    "customer_takes": "TAKEN"
                },
                merchandise_statuses: [
                    {value: null, text: "ALL" },
                    {value: 1, text: "IN-STOCK"},
                    {value: 2, text: "BACKORDER"},
                    {value: 3, text: "SPECIAL"},
                ],
                payment_methods: [
                    {value: null, text: "ALL"},
                    {value: 'cash', text: "CASH"},
                    {value: 'cc', text: "CC"},
                    {value: 'finance', text: "FINANCE"},
                    {value: 'store_credit', text: "STORE CREDIT"},
                ],
                // Order Type Filter
                order_type: null,
                order_type_options: [
                    {value: null, text: "ALL ORDER TYPES"},
                    {value: 'home_delivery', text: "HOME DELIVERY"},
                    {value: 'store_pickup', text: "STORE PICKUP"},
                    {value: 'customer_takes', text: "CUSTOMER TAKES"},
                ],
                vendor_order_statuses_dict: {
                    0: "OPEN",
                    1: "ORDERED",
                    2: "IN-TRANSIT",
                    3: "DELIVERED",
                    4: "DISCONTINUED"
                },
                vendor_order_obj: {},
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                states: mappings.states,
                states_dict: mappings.states_dict,
                pagination_options: [
                    {value: 100, text: "100 RESULTS"},
                    {value: 200, text: "200 RESULTS"},
                    {value: 500, text: "500 RESULTS"},
                    {value: 1000, text: "1000 RESULTS"},
                    {value: 1000000000000, text: "ALL RESULTS"},
                ],
                nresults: 100,
                filtersVisible: true,
                isMobile: false,
                // Store invoice IDs that have vendor order items
                invoicesWithVendorOrders: new Set(),
                // Loading animation properties
                apiLoading: false,
                loadingMessage: 'Loading Orders',
                loadingProgress: 0,
                currentTipIndex: 0,
                loadingInterval: null,
                tipInterval: null,
                msgInterval: null,
                apiCallStack: 0,
                tips: [
                    "📦 Loading order data...",
                    "🔄 Fetching invoices...",
                    "📊 Processing order details...",
                    "📍 Updating inventory...",
                    "🚚 Checking delivery status...",
                    "✨ Organizing order list...",
                    "💾 Syncing with server..."
                ]
            }
        },
        computed: {
            displayedItems() {
                return this.items.slice(0, this.nresults);
            },
            currentTip() {
                return this.tips[this.currentTipIndex] || this.tips[0];
            }
        },
        methods: {
            // Loading animation methods
            startApiLoading(message = 'Loading Orders') {
                this.apiCallStack++;
                if (!this.apiLoading) {
                    this.startLoadingAnimation(message);
                } else {
                    this.loadingMessage = message;
                }
            },
            stopApiLoading() {
                this.apiCallStack--;
                if (this.apiCallStack <= 0 && this.apiLoading) {
                    this.stopLoadingAnimation(true);
                }
            },
            startLoadingAnimation(message = 'Loading Orders') {
                this.apiLoading = true;
                this.loadingMessage = message;
                this.loadingProgress = 0;
                this.currentTipIndex = 0;
                
                this.loadingInterval = setInterval(() => {
                    if (this.loadingProgress < 90) {
                        this.loadingProgress += Math.random() * 10;
                        if (this.loadingProgress > 90) this.loadingProgress = 90;
                    }
                }, 300);
                
                this.tipInterval = setInterval(() => {
                    if (this.currentTipIndex < this.tips.length - 1) {
                        this.currentTipIndex++;
                    }
                }, 2000);
                
                let messages = ['Loading Orders', 'Fetching Data', 'Processing Records', 'Updating Inventory', 'Finalizing'];
                let msgIndex = 0;
                this.msgInterval = setInterval(() => {
                    if (msgIndex < messages.length - 1) {
                        msgIndex++;
                        this.loadingMessage = messages[msgIndex];
                    }
                }, 1800);
            },
            stopLoadingAnimation(success = true) {
                if (this.loadingInterval) clearInterval(this.loadingInterval);
                if (this.tipInterval) clearInterval(this.tipInterval);
                if (this.msgInterval) clearInterval(this.msgInterval);
                
                if (success) {
                    this.loadingProgress = 100;
                    setTimeout(() => {
                        this.apiLoading = false;
                    }, 500);
                } else {
                    this.apiLoading = false;
                }
            },
            // Check if an invoice has items with vendor order locations
            invoiceHasVendorOrderItems(invoice) {
                // Check if we have items data in the invoice
                if (invoice.items && Array.isArray(invoice.items)) {
                    // Check each item's locsub
                    return invoice.items.some(item => {
                        const locsubValue = item.locsub || '';
                        const locsubDisplay = this.packet.locsubsdict[locsubValue] || '';
                        return locsubDisplay.includes('CUSTOMER VENDOR ORDERS');
                    });
                }
                
                // If no items data, check if we have this invoice in our tracked set
                return this.invoicesWithVendorOrders.has(invoice.invoice_id);
            },
            
            // Process items after fetching to identify which invoices have vendor order items
            processInvoiceItems() {
                this.invoicesWithVendorOrders.clear();
                
                this.items.forEach(invoice => {
                    // If we have expanded items data
                    if (invoice.products && invoice.products[0] && invoice.products[0].items) {
                        const hasVendorOrder = invoice.products[0].items.some(product => {
                            const locsubValue = product.locsub || '';
                            const locsubDisplay = this.packet.locsubsdict[locsubValue] || '';
                            return locsubDisplay.includes('CUSTOMER VENDOR ORDERS');
                        });
                        
                        if (hasVendorOrder) {
                            this.invoicesWithVendorOrders.add(invoice.invoice_id);
                        }
                    }
                });
            },
            
            getOrderTypeSummary: function(item) {
                const summary = [];
                if (item.home_delivery_count > 0) summary.push(`${item.home_delivery_count} HDL`);
                if (item.store_pickup_count > 0) summary.push(`${item.store_pickup_count} STP`);
                if (item.customer_takes_count > 0) summary.push(`${item.customer_takes_count} TKN`);
                return summary.length > 0 ? summary.join(" | ") : "No Type";
            },
            
            getMerchandiseStatusLabel: function(status) {
                const statusObj = this.merchandise_statuses.find(s => s.value === status);
                return statusObj ? statusObj.text : 'Unknown';
            },
            
            handleResize() {
                this.isMobile = window.innerWidth < 768;
            },

            getProductDisplayLocsub: function(product) {
                return  product.locsub || product.original_locsub;
            },

            updateProductLocsub: function(item, product, newValue) {
                this.$set(product, 'locsub', newValue);
                if (this.saveItem) {
                    this.saveItem(item, item.products[0].items);
                }
            },
            
            getAvailableLocsubs: function(product) {
                if (!product || !this.all_loc_inventory_dict) return [];
                return this.packet.locsubs.filter(locsub => {
                    if (!locsub) return false;
                    if (product.locsub === locsub.value) {
                        return true;
                    }
                    const inventoryKey = this.concater([product.product_sku, locsub.location_id, locsub.sublocation_id]);
                    const inventoryCount = this.all_loc_inventory_dict[inventoryKey] || 0;
                    return inventoryCount > 0;
                });
            },
            
            isOutOfStock: function(product, locsub) {
                if (!product || !locsub || !this.all_loc_inventory_dict) return false;
                const inventoryKey = this.concater([product.product_sku, locsub.location_id, locsub.sublocation_id]);
                const inventoryCount = this.all_loc_inventory_dict[inventoryKey] || 0;
                return inventoryCount <= 0;
            },
            
            void_invoice: function(invoice_id){
                let that = this;
                let path = "/api/sales/void_invoice/";
                let data = {invoice_id: invoice_id};
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "DELETED INVOICE SUCCESSFULLY",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.items = that.items.filter(function(d){return d.invoice_id != invoice_id});
                        that.invoicesWithVendorOrders.delete(invoice_id);
                    }
                }
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error voiding invoice.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                Requestor.postSyncP(path, data, this, s, f);
            },
            
            init_location_options: function() {
                this.location_options = [{ value: null, text: 'ALL LOCATIONS' }];
                const excluded = ["OUT OF STOCK", "101 WH", "9TH ST ", "ONLINE SALES", "ALL", "FOLCROFT"];
                for (const [id, name] of Object.entries(this.packet.locationsdict || {})) {
                    if (!excluded.includes(name.toUpperCase())) {
                        this.location_options.push({
                            value: parseInt(id),
                            text: name.toUpperCase()
                        });
                    }
                }
            },
            
            update_special_sku: function(item, product){
                let that = this;
                let path = "/api/sales/update_special_sku/"
                let data = {invoice_id: item.invoice_id, itemid: product.itemid, product_sku: product.product_sku}
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully updated special product sku.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "Error updating special product sku.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            change_invoice_completed_status: function(item){
                let that = this;
                let path = "/api/sales/change_invoice_completed_status/"
                let data = {invoice_id: item.invoice_id, status: true}
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully marked invoice as completed.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        item.completed =true;
                    }
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "Error marking invoice as completed.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            apply_delivery_date_to_all: function(item , product){
                item.products[0].items = item.products[0].items.map(function(d){
                    d.delivery_date = product.delivery_date;
                    d.pull_date = moment(product.delivery_date).add(-1, 'day').format("MM-DD-YYYY");
                    return d
                })
                this.saveItem(item, item.products[0].items);
            },
            
            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid= item.itemid;
                this.$bvModal.show("modal-comments-all-orders");
            },
            
            allow_modify_item: function(product, allow_modify){
                let data = {
                    invoice_id: product.invoice_id,
                    itemid: product.itemid,
                    allow_modify: allow_modify
                }
                let that = this;
                let path = "/api/sales/allow_modify_item/"
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully allowed item to be modified",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        product.modifiable = !product.modifiable;
                    }
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "Error allowing item to be modified",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            get_invoice_background: function(item){
                if (item.status == 0){
                    return "white"
                }
                else {
                    if (item.items_in_stock == item.n_items) {
                        return "green"
                    }
                    else {
                        if (item.has_vendor_items > 0){
                            if (item.has_discontinued_items > 0){
                                return "#f8bbd0"
                            }
                            else {
                                return "yellow"
                            }
                        }
                    }
                }
            },
            
            show_vendor_order: function(vendor_order_id, invoice_id, itemid, invoice){
                this.vendor_order_obj = {
                    vendor_order_id: vendor_order_id,
                    invoice_id: invoice_id,
                    itemid: itemid,
                    item: invoice
                }
                this.$bvModal.show("modal-vendor-order-all-orders");
            },
            
            mark_processed: function(item){
                let data = { invoice_id: item.invoice_id }
                let that = this;
                let path = "/api/sales/mark_processed/"
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        item.status = 1
                    }
                    item.loading = false;
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "Error marking invoice as processed. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.loading = false;
                }
                item.loading = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            
            refresh_vendor_order: function(e){
                this.update_single_invoice(this.vendor_order_obj.item, true);
            },
            
            update_single_invoice: function(invoice, force_show_details){
                let path = "/api/sales/get_all_invoices/"
                let data = { invoice_id: invoice.invoice_id }
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        let updated = response.data.result[0];
                        that.items = that.items.map(function(d){
                            if (d.invoice_id == invoice.invoice_id){
                                return updated
                            }
                            else {
                                return d
                            }
                        });
                        that.show_details(updated, force_show_details);
                        // Reprocess after update
                        that.processInvoiceItems();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error updating invoice. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.getAsyncP(path, data, this, s, f);
            },
            
            create_vendor_order: function(product){
                let data = {
                    invoice_id: product.invoice_id,
                    itemid: product.itemid,
                    product_sku: product.product_sku,
                    product_id: ((product.is_special) ? -1 : product.product_id ),
                    vendor: product.vendor,
                    vendor_invoice_id: null,
                    quantity: product.quantity,
                    comment_txt: null,
                    merchandise_status: ((product.item_type == 1) ? 2 : 3),
                    vendor_order_type: ((product.is_special) ? 2 : 1 ),
                    last_action_user: this.packet.userDetails.username,
                    created_user: this.packet.userDetails.username
                }

                if (product.vendor_order_id){
                    this.$vex.dialog.alert({
                        message: "An order already exists with the vendor for these items."
                    });
                    return
                }

                let order_type = null;
                if (data.merchandise_status == 2){
                    order_type = "back order with vendor"
                }
                else if (data.merchandise_status == 3) {
                    order_type = "special order with vendor"
                }

                let that = this;
                let path = "/api/sales/create_vendor_order/"
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Created a new "+order_type+".",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        let result = response.data.result;
                        if (result.length > 0){
                            let vo = result[0];
                            product.vendor_order_id = vo.vendor_order_id;
                            product.vendor_invoice_id = vo.vendor_invoice_id;
                            product.vendor_order_status = vo.vendor_order_status;
                            product.vendor_order_date = vo.vendor_order_date;
                            product.vendor_order_vendor = vo.vendor_order_vendor;
                            product.vendor_order_quantity = vo.vendor_order_quantity;
                        }
                        // Reprocess after creating vendor order
                        that.processInvoiceItems();
                    }
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "Error creating new vendor order. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            saveItem: function(item, products){
                let that = this;
                let dates = {};
                item.products[0].items = item.products[0].items.map(function(d){
                    d.pull_date =  moment(d.delivery_date).add(-1, 'day').format("MM-DD-YYYY");
                    return d;
                })

                let data = {
                    invoice_id: item.invoice_id,
                    items: (products || item.products).map(function(product){
                        dates[product.itemid] = {
                            pull_date: moment(product.delivery_date).add(-1, 'day').format("MM-DD-YYYY"),
                            delivery_date: product.delivery_date
                        }
                        return {
                            itemid: product.itemid,
                            merchandise_status: product.merchandise_status,
                            locsub: product.locsub,
                            delivery_locsub: product.delivery_locsub,
                            delivery_date: product.delivery_date,
                            pull_date: moment(product.delivery_date).add(-1, 'day').format("MM-DD-YYYY"),
                            product_id: product.product_id,
                            product_sku: product.product_sku,
                            is_special: product.is_special,
                            username: that.packet.userDetails.username
                        }
                    })
                }

                let v1 = data.items.filter(function(product){
                    return moment(product.pull_date).startOf('day') >= moment(product.delivery_date).startOf('day')
                });

                if (v1.length > 0){
                    this.$vex.dialog.alert({
                        message: "PULL DATE FOR ALL ITEMS SHLD BE BEFORE THEIR DELIVERY DATE."
                    });
                    return
                }

                let path = "/api/sales/save_invoice_items_mass/"
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Saved item.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        // Reprocess after saving
                        that.processInvoiceItems();
                    }
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error saving item. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }

                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            assign_all: function(item){
                let that = this;
                let products = item.products[0].items;
                products = products.map(function(d){
                    let all_avails = Object.keys(that.all_loc_inventory_dict).filter(function(e){
                        return (e.split("|")[0] == d.product_sku) && (d.quantity <= that.all_loc_inventory_dict[e] )
                    });

                    if (all_avails.length > 0){
                        let locsub = all_avails[0].split("|")[1]+"|"+all_avails[0].split("|")[2]
                        if (d.order_type != 'customer_takes'){
                            d.locsub = locsub;
                            d.merchandise_status = 1;
                        }
                    }
                    return d
                })
            },
            
            show_details: function(item, force_show_details){
                if (force_show_details){
                    item.show_details = true;
                    item.loading = true;
                }
                else {
                    item.show_details = !item.show_details;
                    item.loading = !item.loading;
                }

                if (item.show_details){
                    let that = this;
                    let path = "/api/sales/get_invoice_items2/"
                    let data = {invoice_id: item.invoice_id}

                    let s = function(response){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        else {
                            item.products = response.data.result;
                            if (force_show_details){
                                item.show_details = true;
                            }
                            // Process items after loading details
                            that.processInvoiceItems();
                        }
                        item.loading = false;
                    }
                    let f = function(error){
                        that.$bvToast.toast(
                            "Error loading item. Please try again.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        item.loading = false;
                        item.show_details = false;
                    }

                    Requestor.getAsyncP(path, data, this, s, f);
                }
                else {
                    item.products =[];
                    item.loading = false;
                }
            },
            
            concater: function(items){
                let out = items.join("|")
                return out
            },
            
            fetch_data_pending: function(e){
                if (e){
                    e.preventDefault()
                }
                this.startApiLoading('Loading Pending Orders');
                let path = "/api/sales/get_all_invoices/"
                let data = {pending: true, is_layaway: false}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                        // Process items after fetching
                        that.processInvoiceItems();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                    that.stopApiLoading();
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading data. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                    that.stopApiLoading();
                }
                this.items_being_loaded = true;
                this.items = [];
                Requestor.getAsyncP(path, data, this, s, f);
            },
            
            fetch_data: function(e){
                if (e){
                    e.preventDefault()
                }
                this.startApiLoading('Fetching Orders');
                let path = "/api/sales/get_all_invoices/"
                let data = {
                    status: this.status,
                    order_date_start: this.order_date_range[0],
                    order_date_end: this.order_date_range[1],
                    order_date: this.order_date,
                    invoice_id: this.invoice_id,
                    merchandise_status: this.merchandise_status,
                    payment_method: this.payment_method,
                    is_layaway: false,
                    location_id: this.location_id,
                    order_type: this.order_type,
                }

                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                        // Process items after fetching
                        that.processInvoiceItems();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                    that.stopApiLoading();
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading data. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                    that.stopApiLoading();
                }
                this.items_being_loaded = true;
                this.items = [];
                Requestor.getAsyncP(path, data, this, s, f);
            },
            
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/inventory/get_all_loc_inventory_dict/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.all_loc_inventory_dict = response.data.result;
                                that.allowed_locsubs = that.packet.locsubs.filter((d) => d);
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error,
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading inventory.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ];

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            
            navigateToInvoice: function(invoice_id){
                let route = this.$router.resolve({path: "/sales/viewsale/"+invoice_id+"/"});
                window.open(route.href, '_blank');
            },
            
            distincts: function(arr, key){
                let that = this;
                if (key == "order_type"){
                    arr = arr.map(function(d){ return {order_type: that.order_types_dict[d.order_type] } })
                }
                return arr.reduce((acc, d) => acc.includes(d[key]) ? acc : acc.concat(d[key]), []).join(" | ")
            },
            
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            },
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.packet.global_vars = global_vars;
            this.fetch_prereqs()
            this.init_location_options();
        },
        mounted: function() {
            this.handleResize();
            window.addEventListener("resize", this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.handleResize);
            this.stopLoadingAnimation();
        },
    }
</script>

<style scoped>
    /* Glass Theme Background */
    .glass-theme {
        position: relative;
        background: transparent !important;
        min-height: 100vh;
    }

    .glass-theme::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        filter: blur(10px);
        opacity: 0.5;
        z-index: -2;
        transform: scale(1.1);
    }

    /* Page Entrance Animation */
    @keyframes fadeInPage {
        from {
            opacity: 0;
            transform: translateY(24px);
            filter: blur(2px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
            filter: blur(0);
        }
    }

    .fade-in-page {
        animation: fadeInPage 0.7s cubic-bezier(0.2, 0.9, 0.4, 1.1);
    }

    /* Row Fade Animation */
    @keyframes fadeInRow {
        from {
            opacity: 0;
            transform: translateX(-8px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    .fade-in-row {
        opacity: 0;
        animation: fadeInRow 0.28s cubic-bezier(0.2, 0.9, 0.4, 1) forwards;
    }

    /* Glass Card */
    .glass-card {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 20px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    /* Glass Alert */
    .glass-alert {
        background: rgba(255, 255, 255, 0.7) !important;
        backdrop-filter: blur(5px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 12px !important;
    }

    /* Glass Button */
    .glass-btn {
        background: linear-gradient(135deg, rgba(54, 64, 80, 0.9), rgba(54, 64, 80, 0.95)) !important;
        color: white !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        transition: all 0.2s ease !important;
    }

    .glass-btn:hover {
        background: linear-gradient(135deg, rgba(54, 64, 80, 1), rgba(54, 64, 80, 1)) !important;
        transform: translateY(-1px) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
    }

    .glass-btn-small {
        background: rgba(54, 64, 80, 0.85);
        color: white;
        border: none;
        border-radius: 6px;
        padding: 4px 10px;
        cursor: pointer;
        transition: all 0.2s;
        font-size: 11px;
    }

    .glass-btn-small:hover {
        background: rgba(54, 64, 80, 1);
        transform: translateY(-1px);
    }

    /* Glass Table Container */
    .glass-table-container {
        background: rgba(255, 255, 255, 0.7);
        backdrop-filter: blur(5px);
        border-radius: 16px;
        padding: 8px;
    }

    /* Header Column Styles */
    .header-col {
        background: rgba(54, 64, 80, 0.95);
        color: white;
        font-weight: bold;
        font-size: 11px;
        padding: 8px 2px;
        text-align: center;
        border-right: 1px solid rgba(255, 255, 255, 0.15);
        letter-spacing: 0.5px;
        text-transform: uppercase;
    }

    /* Loading Overlay Styles */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(20px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loading-overlay-enter-active {
        animation: fadeIn 0.3s ease;
    }

    .loading-overlay-leave-active {
        animation: fadeOut 0.3s ease;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
    }

    .loading-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(245, 245, 245, 0.95));
        border-radius: 24px;
        padding: 48px 56px;
        text-align: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: cardPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        max-width: 450px;
        width: 90%;
    }

    @keyframes cardPop {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .loading-animation {
        margin-bottom: 32px;
    }

    .loading-ring {
        position: relative;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border: 4px solid transparent;
        border-radius: 50%;
        animation: ringRotate 1.5s linear infinite;
    }

    .ring:nth-child(1) {
        border-top-color: #4299e1;
        border-left-color: #4299e1;
        animation-duration: 1s;
    }

    .ring:nth-child(2) {
        border-right-color: #48bb78;
        border-bottom-color: #48bb78;
        width: 80%;
        height: 80%;
        top: 10%;
        left: 10%;
        animation-duration: 1.2s;
        animation-direction: reverse;
    }

    .ring:nth-child(3) {
        border-left-color: #ed8936;
        border-bottom-color: #ed8936;
        width: 60%;
        height: 60%;
        top: 20%;
        left: 20%;
        animation-duration: 0.8s;
    }

    @keyframes ringRotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .loading-logo {
        font-size: 32px;
        font-weight: bold;
        animation: logoPulse 1.5s ease-in-out infinite;
        z-index: 1;
    }

    .loading-logo i {
        font-size: 40px;
        background: linear-gradient(135deg, #4299e1, #48bb78);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }

    @keyframes logoPulse {
        0%, 100% { transform: scale(1); opacity: 0.7; }
        50% { transform: scale(1.1); opacity: 1; }
    }

    .loading-text {
        margin-bottom: 24px;
    }

    .loading-text h3 {
        color: #2d3748;
        font-size: 1.3rem;
        margin-bottom: 8px;
        display: inline-block;
    }

    .loading-dots {
        display: inline-flex;
        margin-left: 8px;
    }

    .loading-dots .dot {
        width: 6px;
        height: 6px;
        background: #4299e1;
        border-radius: 50%;
        margin: 0 2px;
        animation: dotBounce 1.4s ease-in-out infinite;
    }

    .loading-dots .dot:nth-child(1) { animation-delay: 0s; }
    .loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes dotBounce {
        0%, 60%, 100% { transform: translateY(0); }
        30% { transform: translateY(-8px); }
    }

    .loading-progress {
        width: 100%;
        height: 4px;
        background: #e2e8f0;
        border-radius: 4px;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1);
        background-size: 200% 100%;
        animation: progressShine 1.5s linear infinite;
        transition: width 0.3s ease;
        border-radius: 4px;
    }

    @keyframes progressShine {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }

    .loading-tips {
        margin-top: 20px;
    }

    .tip-text {
        color: #718096;
        font-size: 0.9rem;
        animation: tipFade 0.5s ease;
    }

    @keyframes tipFade {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Original Styles */
    h5, h4, h3 {
        margin: 0px;
    }

    .tdfonter {
        font-size: 10px;
    }

    .ipt_tdr2 {
        border: 1px dotted black;
        text-align: center;
        font-size: 13px;
    }

    .ipt_tdr3 {
        border: 1px solid black;
        text-align: center;
        font-size: 12px;
        padding: 1px;
        background: beige;
    }

    .ipt_tdhr2 {
        border: 1px solid black;
        text-align: center;
        background: beige;
        font-size: 11px;
        font-weight: normal;
        padding: 1px;
        background: lightgray;
    }

    .card-body {
        padding: 3px !important;
    }

    .b-col1 {
        border: 1px solid gray; 
        text-align: center; 
        padding: 2px;
        background: rgba(255, 255, 255, 0.6);
    }

    .mx-datepicker svg {
        display: none;
    }

    .mx-input {
        font-size: 12px !important;
        width: 100px !important;
    }
    
    /* Highlight for invoices with vendor order items */
    .invoice-with-vendor-orders {
        background-color: rgba(255, 243, 205, 0.9) !important;
        border: 2px solid #ffc107 !important;
        box-shadow: 0 0 8px rgba(255, 193, 7, 0.5);
    }
    
    /* Ensure the inner container also gets the background */
    .invoice-with-vendor-orders .b-container {
        background-color: rgba(255, 243, 205, 0.9) !important;
    }
    
    /* Style for the invoice header row */
    .invoice-with-vendor-orders .b-row:first-child {
        background-color: rgba(255, 243, 205, 0.9) !important;
        font-weight: bold;
    }

    /* Responsive */
    @media (max-width: 768px) {
        .b-col1 {
            font-size: 10px;
        }
        
        .loading-card {
            padding: 32px 24px;
        }
        
        .header-col {
            font-size: 9px;
            padding: 6px 1px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsAllOrders2.vue